module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0102.jpg?v=08687f88";